import dayjs from 'dayjs';
import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/deliverynotes';

export const downloadXlsx = async ({ filters, page, size, workcode }) => {
  const sortable = filters.sortable;
  const project = filters.pid;
  delete filters.pid;
  delete filters.sortable;
  const parsedFilters = Object.entries(filters)
    .map(([keyBy, value]) => {
      if (value === 'NONE' || !value) {
        return null;
      }
      return `&${keyBy}=${value}`;
    })
    .filter((query) => query !== null);
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        endPoint.concat(
          `/download?${project ? `project=${project}` : ''}${
            page ? `&page=${page}` : ''
          }${size ? `&size=${size}` : ''}${
            sortable && !sortable.includes('NONE')
              ? `&orderBy=${sortable.replace('-', ':')}`
              : ''
          }${parsedFilters.length ? parsedFilters.join('') : ''}`,
        ),
        {
          responseType: 'blob',
        },
      );

      const fileName = `${workcode}_TRAZABILIDAD_${dayjs().format(
        'YYYYMMDD',
      )}.xlsx`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const saveDeliveryNote = async (body) => {
  return axios
    .post(endPoint, body)
    .then((res) => res)
    .catch((error) => error.response);
};

export const getDeliveryNote = async ({ id }) => {
  return axios
    .get(endPoint.concat(`/${id}`))
    .then((res) => res)
    .catch((error) => {
      if (error.response.status !== 404) console.error({ error });
    });
};

export const updateDeliveryNote = async (deliveryNote) => {
  return axios
    .put(endPoint.concat(`/${deliveryNote.id}`), deliveryNote)
    .then((res) => res)
    .catch((error) => {
      console.error('Error updating delivery note:', error);
      return error.response;
    });
};

export const listDeliveryNote = async ({ filters, page, size }) => {
  const sortable = filters.sortable;
  const project = filters.pid;
  delete filters.pid;
  delete filters.sortable;
  const parsedFilters = Object.entries(filters)
    .map(([keyBy, value]) => {
      if (value === 'NONE' || !value) {
        return null;
      }
      return `&${keyBy}=${value}`;
    })
    .filter((query) => query !== null);

  return axios
    .get(
      endPoint.concat(
        `?${project ? `project=${project}` : ''}${page ? `&page=${page}` : ''}${
          size ? `&size=${size}` : ''
        }${
          sortable && !sortable.includes('NONE')
            ? `&orderBy=${sortable.replace('-', ':')}`
            : ''
        }${parsedFilters.length ? parsedFilters.join('') : ''}`,
      ),
    )
    .then((res) => res)
    .catch((error) => error.response);
};

export const getPlants = async (pid) => {
  return axios.get(`${endPoint}/plants/project/${pid}`);
};
